export default __webpack_public_path__ + "static/media/Ballon dOr.af2fc926.jpg";